import React from "react";
import { BaseProps } from "./types";
import { NativeSelect } from "./native";
import { CustomSelect } from "./custom";
import { UAParser } from "ua-parser-js";

interface Props extends BaseProps {}

const SelectComponent: React.FC<Props> = (props) => {
	const agent = new UAParser().getResult();
	const native =
		agent.device.type === "mobile" || agent.device.type === "tablet";
	return native ? <NativeSelect {...props} /> : <CustomSelect {...props} />;
};

export const Select = React.memo(SelectComponent);
